export default "__VITE_ASSET__BlyIp7Zi__"